import React from 'react';
import _ from 'lodash';
import {
  Box,
  SkeletonGroup,
  SkeletonRectangle,
  SkeletonLine,
} from '@wix/design-system';
import s from '../TemplateCard.module.scss';

const TemplateLoadingCard = React.forwardRef((_props: {}, ref: any) => {
  return (
    <SkeletonGroup skin="light">
      <Box
        className={s.template}
        direction="vertical"
        minWidth="218px"
        minHeight="322px"
        padding="12px"
        overflow="hidden"
        borderRadius="4px"
      >
        <div ref={ref} />
        <div className={s.skeletonRectStyle}>
          <SkeletonRectangle />
        </div>
        <Box direction="horizontal" width="100%" align="space-between">
          <SkeletonLine width="132px" marginTop="12px" />

          <div className={s.skeletonLineStyle}>
            <SkeletonLine width="32px" marginTop="12px" />
          </div>
        </Box>
        <SkeletonLine width="132px" marginTop="4px" />
        <SkeletonLine width="46px" marginTop="36px" />
      </Box>
    </SkeletonGroup>
  );
});

export default TemplateLoadingCard;
